

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler (evt) {
        evt.preventDefault();
        const regionId = document.querySelector('#product_region_id');
        const regionIdValue = regionId.getAttribute('region-id');
        if (regionIdValue === 'United Kingdom' || regionIdValue === 'Estonia') {
          let countryCode = document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).dataset.value;
          let cart = await fetch('/cart.js').then(r => r.json());
          let conCode = null;
          if(cart.item_count>0){
            for(item of cart.items){
              conCode = item.properties['_region'];
              if(conCode !== regionIdValue){
                const buttons = document.querySelector('.product-form__submit[id^="ProductSubmitButton-"]');
                 const tooltip = document.querySelector(".region-tooltip");
                  tooltip.style.display = "block";
                  const rect = buttons.getBoundingClientRect();
                return;
              }
            }
          }
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const region = formData.get('properties[_region]');
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

      // Select all quantity_icon_input elements with variant_id and data-quantity attributes
       const regionInput = document.querySelector('input[name="properties[_region]"]');
       const regionValue = regionInput ? regionInput.value : '';

        const quantityInputs = document.querySelectorAll('.quantity_icon_input[variant_id]');
        if (quantityInputs.length) {
          quantityInputs.forEach((input, index) => {
            const variantId = input.getAttribute('variant_id');
            const quantity = input.getAttribute('data-quantity') || '0';
            const region = document.querySelector('input[name="properties[_region]"]').value;
    
            if (quantity === '0') {
              //alert(`Quantity for variant ID ${variantId} cannot be zero!`);
                return;
            } else if (variantId && parseInt(quantity) > 0) {
              formData.set(`items[${index}][id]`, variantId);
              formData.set(`items[${index}][quantity]`, quantity);
             if (regionValue) {
               formData.set(`items[${index}][properties][_region]`, region);
             }

            }
          });
        }

        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const matchedItem = cart.items.find(item => {
              return item.properties && item.properties._region === region;
            });

            if (matchedItem) {
            } else {
              return fetch('/cart/clear.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
              });
            }
          })
          .then(() => {
            return fetch(`${routes.cart_add_url}`, config);
          })
          .then((response) => response.json())
          .then((response) => {
            // if (response.selling_plan_allocation) {
            //   if (response.selling_plan_allocation.selling_plan.name === '30 Days') {
            //     response.selling_plan_allocation.selling_plan.description =
            //       'Deposit paid. Remaining amount will be charged after 30th Days.';

            //       console.log(response.selling_plan_allocation.selling_plan.description);
            //   }
            // }
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
// function showRegionPopup(targetBtn) {
//   const tooltip = document.getElementById("region-tooltipcart");
//   tooltip.style.display = "block";
//   const rect = targetBtn.getBoundingClientRect();
// }

function hideRegionTooltip() {
  document.getElementById("region-tooltipproduct").style.display = "none";
}

//document.getElementById("tooltip-cancel").addEventListener("click", hideRegionTooltip);
// document.getElementById("tooltip-clear-cart").addEventListener("click", () => {
//   const regionId = document.querySelector('#product_region_id');
//     if (regionId) {
//       const regionIdValue = regionId.getAttribute('region-id');
//       fetch('/cart/clear.js').then(r => r.json()).then(()=>{
//             document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).click();
//       });
//     }
// });

/*---------------------------(RJ/04/11)-----------------------------------*/
const tooltipClose = document.querySelectorAll(".itg-tooltip-cancel");
const tooltipClear = document.querySelectorAll(".itg-tooltip-clear-cart");
if(tooltipClose.length > 0){
  tooltipClose.forEach(function(tooltip){
    tooltip.addEventListener("click", hideRegionTooltip);
  });
}
if(tooltipClear.length > 0){
tooltipClear.forEach(function(close){
  close.addEventListener("click", () => {
    const regionId = document.querySelector('#product_region_id');
      if (regionId) {
        const regionIdValue = regionId.getAttribute('region-id');
        fetch('/cart/clear.js').then(r => r.json()).then(()=>{
              document.querySelector(`#FooterCountry-country-results li a[id="${regionIdValue}"]`).click();
        });
      } 
  });
});
}



 